<template>
    <div class="escalon-background-image" :style="style"></div>
</template>

<script>
export default {
  name: "BackgroundImage",
  props: {
    image: { type: String, default: "trash-icon.png" }
  },
  computed: {
    style(){
      return {
        "background-image": "url('" + this.src + "')"
      };
    },
    src() {
      return require("../../assets/" + this.image);
    }
  }
}
</script>
